import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from "../../../constants/pages-and-paths";
import {AuthGuardService} from "../../../guards/auth-guard.service";
import {LatestPostComponent} from "./latest-post.component";

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.latestPost.pageInRouting,
    data: { data: PAGES_AND_PATHS.latestPost },
    component: LatestPostComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./latest-post.module').then(m => m.LatestPostModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LatestPostRoutingModule { }
